// removed by extract-text-webpack-plugin
module.exports = {"awards-slider":"awards-slider","slick-initialized":"slick-initialized","slick-track":"slick-track","slick-list":"slick-list","slick-slide":"slick-slide","btn-arrow":"btn-arrow","btn-arrow_left":"btn-arrow_left","awards-slider__item":"awards-slider__item","awards-slider__link":"awards-slider__link","stub":"stub","awards-slider__link-img":"awards-slider__link-img"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_awards.scss
// module id = 75
// module chunks = 0